import { useContext, useState, useEffect } from "react"
import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import OneInput from '../../../../Components/OneInput/OneInput'
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from '../../../../Utils/Utils'
import OneModal from "../../../../Components/OneModal/OneModal"
import { OneSwitch } from "../../../../Components/OneSwitch/OneSwitch"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import OneSelect from "../../../../Components/OneSelect/OneSelect"
import { nivelUsuario } from "../../../../Utils/optionsSelects"
import ModalUploadImage from "./ModalUploadImage/ModalUploadImage"

const montarGrupoPermissao = (grupos) => {
    let result = grupos.map((grupo) => {
        return {
            id: grupo.id,
            descricao: `${grupo.id} - ${grupo.nome}`
        }
    })
    return result
}

// const montarMonitoresDigifort = (monitores) => {
//     let result = []
//     result = monitores.map((monitor) => {
//         return {
//             id: monitor.id,
//             descricao: monitor.descricao
//         }
//     })
//     return result
// }

export const CadastroUsuario = ({ openCadastro, setOpenCadastro, idToEdit, setIdToEdit }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [initialData, setInitialData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [formData, setFormData] = useState()

    const [grupoPermissao, setGrupoPermissao] = useState(null)
    // const [monitorUsuario, setMonitorUsuario] = useState(null)
    const [openUploadImg, setOpenUploadImg] = useState(false)

    const getDadosIniciais = (msg) => {
        if (msg.cmd == 'buscarUsuarioConfig') {
            if (msg.data.status) {
                msg.data.usuario.senha = '*********'
                setInitialData(msg.data.usuario)
            } else {
                showNotify(msg.message)
                setOpenCadastro(false)
            }
        }
        if (msg.cmd == 'buscarListagens') {
            if (msg.data.status) {
                const grupos = montarGrupoPermissao(msg.data.listagens.grupoPermissao)
                setGrupoPermissao(grupos)
                // const monitores_digi = montarMonitoresDigifort(msg.data.listagens.monitoresDigifort)
                // setMonitorUsuario(monitores_digi)
            } else {
                showNotify(msg.message)
                setOpenCadastro(false)
            }
        }
    }

    useEffect(() => {
        addRoute("buscarListagens", getDadosIniciais)
        sendWs("buscarListagens", { listagens: { grupoPermissao: ['id', 'nome'], monitoresDigifort: [] } })
        let stringId = idToEdit != null ? `${idToEdit}` : null
        if (stringId != null) {
            setLoading(true)
            addRoute("buscarUsuarioConfig", getDadosIniciais)
            sendWs("buscarUsuarioConfig", { id: idToEdit, descartaUserOne: true })
        }
    }, [])

    useEffect(() => {
        if (!openUploadImg) {
            setLoading(true)
            sendWs("buscarUsuarioConfig", { id: idToEdit })
        }
    }, [openUploadImg])

    useEffect(() => {
        if ((initialData || idToEdit == null) && grupoPermissao) {
            setLoading(false)
        }
    }, [initialData, grupoPermissao])

    const responseSumbit = (msg) => {
        if (msg.data.status == "error") {
            showNotify("error", msg.data.message)
        } else if (msg.data.status) {
            setIdToEdit(null)
            setOpenCadastro(false)
            showNotify("success", "Usuário salvo com sucesso!")
            sendWs("buscarTodosUsuariosConfig", { descartaUserOne: true })
        } else if (!msg.data.status) {
            showNotify("error", msg.data.message)
        }
    }

    addRoute("editarUsuarioConfig", responseSumbit)
    addRoute("criarUsuarioConfig", responseSumbit)

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            setOpenCadastro(false)
            return
        }
        let data = formData

        if (initialData?.id != null) {
            const newData = { id: initialData?.id }
            for (const prop in initialData) {
                if (Object.hasOwnProperty.call(initialData, prop)) {
                    if (initialData[prop] != data[prop] && data[prop] != undefined) {
                        newData[prop] = data[prop]
                    }
                }
            }
            data = newData

            /* eslint-disable no-useless-escape */
            const regex = /^[\*]*$/ // regex para retornar true caso a string possua somente asterisco

            if (formData.senha && !regex.test(formData.senha)) { // Só entra se a senha tiver algum caracter diferente de *
                data.senha = formData.senha
            }
            sendWs("editarUsuarioConfig", { usuario: data })
        } else {
            delete data.id
            if (!data.ativo) {
                data.ativo = 1
            }
            if (!data.nivel) {
                data.nivel = 3
            }
            sendWs("criarUsuarioConfig", { usuario: data })
        }
    }
    const [showSenha, setShowSenha] = useState(false)
    const [showSenhaCheckin, setShowSenhaCheckin] = useState(false)

    return (
        <OneModal
            open={openCadastro}
            setOpen={setOpenCadastro}
            loading={loading}
            titleText="Usuários"
            FooterButtons={FooterButtons}
        >
            {!loading &&
            <form
                id="usuario-form"
                onSubmit={handleSubmit}
            >
                <Grid
                    xs={12}
                    rowSpacing={0}
                    columnSpacing={1}
                    container
                    gap={0.5}
                    px={1}
                    sx={{ maxWidth: '500px' }}
                >
                    {openUploadImg &&
                        <ModalUploadImage
                            open={openUploadImg}
                            setOpen={setOpenUploadImg}
                            idUser={idToEdit}
                        />
                    }
                    <Grid container xs={12} rowGap={2} sx={{ alignItems: 'center' }}>
                        <Grid container xs={12}>
                            <Grid container xs={12} sm={3.5} sx={{ alignItems: 'center' }}>
                                <Grid xs={3} sm={5}>
                                    <Typography fontSize="13px" fontWeight='400' >Código: </Typography>
                                </Grid>
                                <Grid xs={9} sm={6}>
                                    <OneInput defaultValue={initialData?.id} onChange={handleChange} readOnly={true} disabled={true} name={"id"}/>
                                </Grid>
                            </Grid>
                            <Grid container xs={12} sm={6} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={2} md={5} lg={5}>
                                    <Typography fontSize="13px" fontWeight='400' >Data Cadastro: </Typography>
                                </Grid>
                                <Grid xs={12} sm={9} md={6} lg={6}>
                                    <OneInput defaultValue={initialData?.dataCadastro} onChange={handleChange} readOnly={true} disabled={true} name={"dataCadastro"}/>
                                </Grid>
                            </Grid>
                            <Grid container xs={12} sm sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={4} lg={5}>
                                    <Typography fontSize="13px" fontWeight='400' >Ativo: </Typography>
                                </Grid>
                                <Grid xs={12} sm={4} lg={4}>
                                    <OneSwitch defaultValue={initialData?.ativo} onChange={handleChange} name={"ativo"} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12}>
                            <Grid container xs={12} sm={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={2} lg={1.5}>
                                    <Typography fontSize="13px" fontWeight='400' >*Nome: </Typography>
                                </Grid>
                                <Grid xs={12} sm lg>
                                    <OneInput
                                        defaultValue={initialData?.nome}
                                        onChange={handleChange}
                                        maxLength="50"
                                        autoFocus
                                        required
                                        name={"nome"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12}>
                            <Grid container xs={12} sm={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={2} lg={1.5}>
                                    <Typography fontSize="13px" fontWeight='400' >*Email: </Typography>
                                </Grid>
                                <Grid xs={12} sm lg>
                                    <OneInput
                                        defaultValue={initialData?.email}
                                        onChange={handleChange}
                                        maxLength="60"
                                        name={"email"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }} rowGap={1}> {/* linha */}
                            <Grid container xs={12} lg={6} sx={{ alignItems: 'center' }}> {/* sessao */}
                                <Grid xs={12} lg={3}> {/* elemento */}
                                    <Typography fontSize="13px" fontWeight='400' >Login: </Typography>
                                </Grid>
                                <Grid xs={12} lg={8.5}>{/* elemento */}
                                    <OneInput
                                        defaultValue={initialData?.login}
                                        onChange={handleChange}
                                        maxLength="40"
                                        required
                                        name={"login"}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container xs={12} lg sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={5}>
                                    <Typography fontSize="13px" fontWeight='400' >Senha: </Typography>
                                </Grid>
                                <Grid xs={12} lg>
                                    <OneInput
                                        defaultValue={initialData?.senha}
                                        onChange={handleChange}
                                        type={showSenha ? 'text' : 'password'}
                                        EndIcon={showSenha ? VisibilityOff : Visibility}
                                        IconCallback={() => setShowSenha(!showSenha)}
                                        maxLength="100"
                                        required={!(initialData?.id > 0)}
                                        name={"senha"}
                                        autoComplete="new-password"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }} rowGap={1}> {/* linha */}
                            <Grid container xs={12} lg={6} sx={{ alignItems: 'center' }}> {/* sessao */}
                                <Grid xs={12} lg={3}> {/* elemento */}
                                    <Typography fontSize="13px" fontWeight='400' >Celular: </Typography>
                                </Grid>
                                <Grid xs={12} lg={8.5}>{/* elemento */}
                                    <OneInput
                                        defaultValue={initialData?.celular}
                                        onChange={handleChange}
                                        maxLength="15"
                                        name={"celular"}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container xs={12} lg sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={5}>
                                    <Typography fontSize="13px" fontWeight='400' >Senha Checkin Telefonia: </Typography>
                                </Grid>
                                <Grid xs={12} lg>
                                    <OneInput
                                        defaultValue={initialData?.senha_checkin}
                                        onChange={handleChange}
                                        type={showSenhaCheckin ? 'text' : 'password'}
                                        EndIcon={showSenhaCheckin ? VisibilityOff : Visibility}
                                        IconCallback={() => setShowSenhaCheckin(!showSenhaCheckin)}
                                        maxLength="100"
                                        name={"senha_checkin"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sx={{ alignItems: 'center' }} rowGap={1}> {/* linha */}
                            <Grid container xs={12} lg={6} sx={{ alignItems: 'center' }}> {/* sessao */}
                                <Grid xs={12} lg={3}> {/* elemento */}
                                    <Typography fontSize="13px" fontWeight='400' >Nível: </Typography>
                                </Grid>
                                <Grid xs={12} lg={8.5}>{/* elemento */}
                                    <OneSelect
                                        defaultValue={initialData?.nivel || 3}
                                        onChange={handleChange}
                                        name={"nivel"}
                                        options={nivelUsuario}
                                        valor="nivel"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container xs={12} lg sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={5}>
                                    <Typography fontSize="13px" fontWeight='400' >Grupo de permissão: </Typography>
                                </Grid>
                                <Grid xs={12} lg>
                                    <OneSelect
                                        defaultValue={initialData?.idGrupoPermissao}
                                        onChange={handleChange}
                                        name={"idGrupoPermissao"}
                                        options={grupoPermissao}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12}>
                            <Grid container xs={12} sm={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={3} lg={3}>
                                    <Typography fontSize="13px" fontWeight='400' >*Foto do Perfil: </Typography>
                                </Grid>
                                <Grid container xs={12} sm lg>
                                    <Grid>
                                        <img
                                            style={{
                                                maxHeight: '100px',
                                                maxWidth: '100px',
                                                display: initialData?.img_perfil ? '' : 'none'
                                            }}
                                            src={`${window.location.origin.replace(':3003', '')}/wsOnePortaria/images/imgUsuarios/${initialData?.img_perfil}?df=${Math.floor(Date.now() / 1000)}`} />
                                    </Grid>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', alignContent: 'center' }}>
                                        <Button color="one_primary" variant="contained" onClick={() => { setOpenUploadImg(true) }}>Upload</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* <Grid container xs={12} sx={{ alignItems: 'center' }} rowGap={1}>
                            <Grid container xs={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} lg={3}>
                                    <Typography fontSize="13px" fontWeight='400' >Monitor Digifort: </Typography>
                                </Grid>
                                <Grid xs={12} lg={8.5}>
                                    <OneSelect
                                        defaultValue={initialData?.monitor_usuario}
                                        onChange={handleChange}
                                        options={monitorUsuario}
                                    />
                                </Grid>
                            </Grid>
                        </Grid> */}

                    </Grid>
                </Grid>
            </form>
            }
        </OneModal>
    )
}

export const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="usuario-form" type="submit">Salvar</Button>
        </Grid>
    )
}
